import React from 'react';
import { cn } from '@/utils/cn';
import { securityData } from '@/config/securityData';

interface TrustCardProps {
  title: string;
  description: string;
  ctaText: string;
  ctaHref: string;
  link1Text?: string;
  link1Href?: string;
  link2Text?: string;
  link2Href?: string;
  className?: string;
}

const TrustCard: React.FC<TrustCardProps> = ({
  title,
  description,
  ctaText,
  ctaHref,
  link1Text = securityData.policies.supportPolicy.text,
  link1Href = securityData.policies.supportPolicy.href,
  className,
}) => {


  return (
    <section className={cn('py-16', className)}>
      <div className="container mx-auto px-4">
        <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-12 max-w-4xl mx-auto">
          <h2 className="text-3xl font-bold text-center mb-6">{title}</h2>
          <p className="text-gray-600 text-center mx-auto max-w-3xl mb-8">
            {description}
          </p>
          <div className="text-center">
            <div className="flex items-center justify-center gap-8">
              <a
                href={ctaHref}
                className="text-primary-600 hover:text-primary-700"
                target="_blank"
                rel="noopener noreferrer"
              >
                {ctaText}
              </a>
              <a
                href={link1Href}
                className="text-primary-600 hover:text-primary-700"
                target="_blank"
                rel="noopener noreferrer"
              >
                {link1Text}
              </a>

            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TrustCard;